export enum PmvCrudTypeEnum {
  NEW_PMV = 'newPmv',
  UPDATE_PMV = 'updatePmv',
}

export type PmvCrudType = {
  type: PmvCrudTypeEnum;
  id: string;
  onClose: () => void;
  onGoingBack: () => void;
};

export type PmvManageType = {
  type: PmvCrudTypeEnum;
  id: string;
};
